<template>
    <Menu  :theme="theme" width="200" @on-select="n=>$emit('on-select',n)">
        <!-- 循环遍历所有的菜单数据 -->
        <template v-for="item in menus">
            <!-- 如果不包含子项集合 -->
            <MenuItem v-if="!hasChildren(item)" :name="item.name" :key="item.id">
                <Icon v-if="hasIcon(item)" :type="item.icon " size=14  :key="`menuicon${item.name}`" style="margin-top:-4px"></Icon>
                <span class="layout-text" :key="`title${item.name}`">{{item.title}}</span>  
            </MenuItem>
            <sub-sider-bar  v-else  :item="item" :key="item.id" />
        </template>
    </Menu>
</template>
<script>
import SubSiderBar from './sub-sider-bar'
import {mapGetters} from 'vuex'
import {mixins} from './sider'
export default {
    components:{SubSiderBar},
    mixins:[mixins],
}
</script>

